import { LinkItem } from '@occc-app/design-system';

import { routeCreator as scanDataRouteCreator } from '../../scan-data.router';

export const buildScanDataPastSubmissionBreadcrumbs = (label: string): LinkItem[] => [
  {
    label: 'Tobacco Offers',
    to: scanDataRouteCreator.base(),
  },
  { label },
];
